import { fetchRefreshToken } from './fetchRefreshToken';
import { removeCodeFromLocation } from './removeCodeFromLocation';
import { removeStateFromStorage } from './removeStateFromStorage'
import { AES, enc } from 'crypto-js';
import store from '../../Redux/_helpers/store';
import { success } from '../../Redux/_actions/login.actions';
import Cookies from 'cookies-js';
import { successManageProfile } from '../../Redux/_actions/manageProfile.action';
import { successUserProfileInfo } from '../../Redux/_actions/userProfileInfo.action';
import { ApiCall } from '../../Services/utils/ApiCall';
import { baseURL } from '../../Services/config/apiGateway';
import { USER_PROFILE_DETAILS } from '../../Services/config/apiEndPoints';
import { v4 as uuidv4 } from 'uuid';
import {fetchTokenPath,redirectURIPath} from '../../Services/config/apiGateway'


export const fetchToken = ({ clientId, scopes, clientSecret, code, state, tokenEndpoint, fetch = window.fetch, storage = sessionStorage, }) => {
  let uuID = uuidv4();
  const payload = {
    //client_id: '8c19ff6c-0af1-48e9-b5ef-005a9a59e409',
    code,
    grant_type: 'authorization_code',
    code_verifier: state.encodedVerifier,
    redirect_uri: state.redirect_uri,
    scope: "8c19ff6c-0af1-48e9-b5ef-005a9a59e409 offline_access"
  };
  

  // if (clientSecret) {
  //   payload.client_secret = clientSecret
  // }
  //https://tpt-apim-cargo-test.azure-api.net/ccLogin/v1/tokenprofiledetails?grant_type=authorization_code&client_id=f1d4d39a-5888-481c-a562-a49d7748f054&scope=f1d4d39a-5888-481c-a562-a49d7748f054%20offline_access&code=${code}&redirect_uri=http://localhost:3000&code_verifier={state.encodedVerifier}
  //Working one>> https://tpt-apim-cargo-test.azure-api.net/ccLogin/v1/tokenbackendaggregation?grant_type=authorization_code&client_id=f1d4d39a-5888-481c-a562-a49d7748f054&scope=f1d4d39a-5888-481c-a562-a49d7748f054 offline_access&code=${code}&redirect_uri=http://localhost:3000&code_verifier=${state.encodedVerifier}`
  //https://tptcargodevsa.z1.web.core.windows.net
  return fetch(`${fetchTokenPath}tokenprofiledetails?grant_type=authorization_code&redirect_uri=${redirectURIPath}/&code_verifier=${state.encodedVerifier}&code=${code}`, {
    //return fetch(`https://tpt-apim-cargo-test.azure-api.net/ccLogin/v1/tokenbackendaggregation?grant_type=authorization_code&code=${code}&redirect_uri=https://cargoconnecttest.azureedge.net&code_verifier=${state.encodedVerifier}`, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'x-cc-trace-id': uuID ,
      "channel" : 'web',
      "appVersion" : 'v1.1.0'
      
    },
    method: 'GET',
    //body: new window.URLSearchParams(payload)
  })
    .then(r => {
      if (!r.ok) {
        throw new Error(`Token response not ok, status is ${r.status}`);
      }
      //console.log(r.toS())
      console.log(r, "===>>>>>API Response")
      return r.json();
      //return r
    })
    .then(token => {
      Cookies.set('msAL', token.tokenResponse.access_token, { expires: token.tokenResponse.expires_in, path: '/' });
      Cookies.set('_msAL', token.tokenResponse.access_token, { expires: token.tokenResponse.expires_in, path: '/' });
      // const ccMsalToken = AES.encrypt(JSON.stringify(token.tokenResponse),'itsEncrypted').toString();
      Cookies.set('ccMsal', JSON.stringify(token.tokenResponse), { expires: token.tokenResponse.expires_in, path: '/' });
      Cookies.set('expires', token.tokenResponse.expires_in);
      //alert(cookies.get('msAL')); // Pacman
      const envryptedToken = AES.encrypt(JSON.stringify(token), 'itsEncrypted').toString();
      sessionStorage.setItem("isAuthenticated", envryptedToken);


      const refreshToken = sessionStorage.getItem("isAuthenticated");
      const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
      const decryptedObject = decrypted.toString(enc.Utf8);
      const getRefreshToken = JSON.parse(decryptedObject);
      sessionStorage.setItem("Decrypted Token", JSON.stringify(getRefreshToken))

      //console.log(token.backendResponse,"RESPONSE++++++++")

      // const loginDataStore = {
      //   ...token.backendResponse,
      //   personFirstNameR: token.backendResponse.userDetails.userdetails?.user?.firstName,
      //   personLastNameR: token.backendResponse.userDetails.userdetails?.user?.lastName,
      // }
      if (token.backendResponse) {
        const encryptedToken = AES.encrypt(JSON.stringify(token.backendResponse), 'TPT_CARGO_CONNECT').toString();
        store.dispatch(success(encryptedToken));

        // api call for profile selection
     //   if (token.backendResponse.userType === 'Premium') {


          ApiCall(
            'GET',
            baseURL + USER_PROFILE_DETAILS + `?userName=${token?.backendResponse?.userDetails?.userdetails?.user?.userEmail}`,

            {},
            {
              'Accept': 'application/json',
              'Content-Type': 'application/json',

            },
            false
          ).then(data => {
            if (data.flag != -1) {
              if (data.flag == 500) {
                console.log("I am 500")
              }
              else {
                console.log('I am 200!');
                const encryptedDataUserProfile = AES.encrypt(JSON.stringify(data), 'TPT_CARGO_CONNECT').toString();
                store.dispatch(successUserProfileInfo(encryptedDataUserProfile));
                let rolesData1 = data?.profileRoles.filter(role => !["Preview", "preview"].includes(role.roleType));
                // filter approved index first time
                if (['Premium', 'premium'].includes(token.backendResponse.userType)) {

                  rolesData1?.every((md, index) => {
                    if (['Approved', 'approved'].includes(md.profileStatus)) {

                      console.log('mdPremium', md, index);
                      const data = {
                        selectedProfile: index,
                        selectedProfileType: md.roleType,
                        selectedProfileStatus : md.profileStatus,
                        selectedProfileRoleName : md.roleName
                      }
                      store.dispatch(successManageProfile(data));
                      return false
                    }

                    // console.log(selectedProfileIndex,'selectedProfileIndex');

                    return true

                  })
                }


            
              //  let rolesData1 = data?.profileRoles.filter(role => ["Preview", "preview"].includes(role.roleType));
                // filter approved index first time
                
             
              else if(['Preview', 'preview'].includes(token.backendResponse.userType)) {
              let driverPresent = false;
                rolesData1?.every((md, index) => {
              
                    if (['Driver','driver'].includes(md.roleType) && ["Approved", 'approved'].includes(md.profileStatus)) {
                      driverPresent = true;
                      console.log('mdPreviewDriver', md, index);
                      const data = {
                        selectedProfile: index,
                        selectedProfileType: md.roleType,
                        selectedProfileStatus : md.profileStatus,
                        selectedProfileRoleName : md.roleName
                      }
                      store.dispatch(successManageProfile(data));
                      return false
                    }

                    // console.log(selectedProfileIndex,'selectedProfileIndex');

                    return true

                  })

            
                if(!driverPresent){
                    data?.profileRoles?.every((md, index) => {
                   
                      if (['Preview', 'preview'].includes(md.roleType)) {
                       
                        console.log('mdPreview', md, index);
                        const data = {
                          selectedProfile: index,
                          selectedProfileType: md.roleType,
                          selectedProfileStatus : md.profileStatus,
                          selectedProfileRoleName : md.roleName
                        }
                        store.dispatch(successManageProfile(data));
                        return false
                      }
  
                      return true
  
                    })
                }

                }
                // else if(['Preview', 'preview'].includes(token.backendResponse.userType)){
                
                //   data?.profileRoles?.every((md, index) => {
                 
                //     if (['Preview', 'preview'].includes(md.roleType)) {
                //       alert('hello3')
                //       console.log('mdPreview', md, index);
                //       const data = {
                //         selectedProfile: index,
                //         selectedProfileType: md.roleType,
                //         selectedProfileStatus : md.profileStatus
                //       }
                //       store.dispatch(successManageProfile(data));
                //       return false
                //     }

                //     // console.log(selectedProfileIndex,'selectedProfileIndex');

                //     return true

                //   })
                // }


              
            }
            }

          });
        // } else {
        //   const dataManageProfile = {
        //     selectedProfile: 0,
        //     selectedProfileType: 'Preview',
        //   }
        //   store.dispatch(successManageProfile(dataManageProfile));
        // }
      }



      const { expires_in } = token;
      if (expires_in && Number.isFinite(expires_in)) {
        const slackSeconds = 10;
        // add 'expires_at', with the given slack
        token.expires_at = new Date(new Date().getTime() + expires_in * 1000 - (slackSeconds * 1000));
        console.log(token, "==>>>>> myToken")
        //Refresh Token
        //setCookie('msAL', token.tokenResponse, { path: '/', expires:token.expires_at, maxAge:1000 });


      }
      return token;
    })
    .catch(err => {
      console.error('ERR (fetch)', err);
      throw err;
    });
}
